import { render, staticRenderFns } from "./Comunicado.vue?vue&type=template&id=469c7e17"
import script from "./Comunicado.vue?vue&type=script&lang=js"
export * from "./Comunicado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports